// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"0":"chunk-delete-account","1":"chunk-newsletters-bar"}[chunkId] + "." + {"0":"740b9b16f81d6bf98c35","1":"d63a48d91a43a37ebfd8"}[chunkId] + ".js";
};